export default function idsEqual(left, right) {
  if (left == null || right == null) {
    return false;
  }
  return String(left) === String(right);
}
